import { setCookie } from './Cookies';

const initDialog = () => {
    const body = document.body;

    const dialog = document.getElementById('region-modal');
    if (!dialog) return;
    
    const showButton = document.getElementById('region-selector');
    const closeButton = document.getElementById('region-modal-close');

    const links = Array.from(dialog.querySelectorAll<HTMLAnchorElement>('a[href]'));
    links.forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        if (link.dataset.region) setCookie('preferredRegion', link.dataset.region);
        if (link.href && window.location.href != link.href) window.location.href = link.href;
        closeDialog();
    }));


    const openDialog = () => {
        dialog?.setAttribute('open', 'open');
        body.style.overflow = 'hidden';
    }

    const closeDialog = () => {
        dialog?.removeAttribute('open')
        body.style.overflow = 'auto';
    }

    showButton?.addEventListener('click', () => openDialog());
    closeButton?.addEventListener('click', () => closeDialog());
}

export default initDialog;

